(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1822],{

/***/ 84382:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p/[...slug]",
      function () {
        return __webpack_require__(43141);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TB": function() { return /* binding */ DatatableRow; },
/* harmony export */   "a1": function() { return /* binding */ DatatableCell; },
/* harmony export */   "vo": function() { return /* binding */ DatatableCellPrice; }
/* harmony export */ });
/* unused harmony exports DatatableHeadCell, DatatableHeading, DatatableError */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _NewIcons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20474);
/* harmony import */ var _Tooltip_Tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68709);
/* harmony import */ var _utils_safe__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46052);





var Datatable = function(param) {
    var cols = param.cols, children = param.children;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "datatable",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "datatable__head",
                children: Object.values(cols).map(function(col, index) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DatatableHeadCell, {
                        col: col
                    }, index);
                })
            }),
            children
        ]
    }));
};
var DatatableHeadCell = function(param) {
    var col = param.col;
    // visibili sono nel desktop, quindi non gestisco i casi mobile
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        onClick: col === null || col === void 0 ? void 0 : col.onClick,
        className: 'datatable-headcell' + (col.hidden ? ' u-hidden' : '') + (col.desktopHidden ? ' u-hidden-desktop' : '') + (col.desktopCols ? ' datatable-cell--desktop-cols-' + col.desktopCols : '') + (col.align ? ' u-align-' + col.align : '') + (col.desktopAlign ? ' u-align-' + col.desktopAlign + '-desktop' : ''),
        style: col.width ? {
            flex: 'none',
            width: col.width ? col.width : null
        } : {
            flexGrow: col.grow ? col.grow : null
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DatatableHeading, {
            label: col.label,
            info: col.info
        })
    }));
};
var DatatableHeading = function(param) {
    var label = param.label, info = param.info;
    /* TODO: comportamento di Info? */ return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "datatable-heading",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "datatable-heading__label",
                children: label
            }),
            info && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "datatable-heading__info",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Tooltip_Tooltip__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    label: info,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_NewIcons__WEBPACK_IMPORTED_MODULE_2__/* .Info */ .kI, {})
                })
            })
        ]
    }));
};
var DatatableError = function(param) {
    var error = param.error;
    return error ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "datatable-error",
        children: error
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};
var DatatableRow = function(param) {
    var children = param.children, extra = param.extra, error = param.error, even = param.even, className = param.className;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: 'datatable-row' + (even ? '' : ' datatable-row--odd') + (className ? ' ' + className : '') + ' nobreak',
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "datatable-row__cells",
                children: children
            }),
            extra && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "datatable-row__extra",
                children: extra
            }),
            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "datatable-row__error",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DatatableError, {
                    error: error
                })
            })
        ]
    }));
};
// Se non c'è il parametro col non visualizzo la cella
var DatatableCell = function(param) {
    var col = param.col, error = param.error, children = param.children, className = param.className;
    return col ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: 'datatable-cell' + (col.align ? ' u-align-' + col.align : '') + (col.desktopAlign ? ' u-align-' + col.desktopAlign + '-desktop' : '') + (col.mobileAlign ? ' u-align-' + col.mobileAlign + '-mobile' : '') + (col.mobileOrder ? ' datatable-cell--mobile-order-' + col.mobileOrder : '') + (col.desktopCols ? ' datatable-cell--desktop-cols-' + col.desktopCols : '') + (col.mobileCols ? ' datatable-cell--mobile-cols-' + col.mobileCols : '') + (col.mobileHidden ? ' u-hidden-mobile' : '') + (col.desktopHidden ? ' u-hidden-desktop' : '') + (col.hidden ? ' u-hidden' : '') + (className ? ' ' + className : ''),
        style: col.width ? {
            flex: 'none',
            width: col.width ? col.width : null
        } : {
            flexGrow: col.grow ? col.grow : null
        },
        children: [
            col.label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "datatable-cell__heading",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DatatableHeading, {
                    label: col.label,
                    info: col.info
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "datatable-cell__content",
                children: children
            }),
            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "datatable-cell__error",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DatatableError, {
                    error: error
                })
            })
        ]
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};
// Celle con valori tipizzati
var DatatableCellPrice = function(param) {
    var col = param.col, value = param.value;
    return col ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DatatableCell, {
        col: col,
        children: value ? "".concat((0,_utils_safe__WEBPACK_IMPORTED_MODULE_4__/* .priceNotation */ ._q)(value, 3), " €") : ""
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};
/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(Datatable));


/***/ }),

/***/ 88973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_content_loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24561);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ResponsiveProduct = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, _objectSpread({
        speed: 2,
        width: '100%',
        height: 900,
        viewBox: "0 0 1280 900",
        backgroundColor: "#f3f3f3",
        foregroundColor: "#ecebeb"
    }, props, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "753",
                y: "419",
                rx: "5",
                ry: "5",
                width: "510",
                height: "2"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "147",
                y: "24",
                rx: "0",
                ry: "0",
                width: "540",
                height: "540"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "12",
                y: "25",
                rx: "0",
                ry: "0",
                width: "104",
                height: "109"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "11",
                y: "165",
                rx: "0",
                ry: "0",
                width: "104",
                height: "109"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "11",
                y: "305",
                rx: "0",
                ry: "0",
                width: "105",
                height: "109"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "753",
                y: "27",
                rx: "0",
                ry: "0",
                width: "160",
                height: "18"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "753",
                y: "63",
                rx: "0",
                ry: "0",
                width: "496",
                height: "32"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "753",
                y: "189",
                rx: "0",
                ry: "0",
                width: "45",
                height: "16"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "753",
                y: "224",
                rx: "0",
                ry: "0",
                width: "80",
                height: "80"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "11",
                y: "451",
                rx: "0",
                ry: "0",
                width: "105",
                height: "109"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "73",
                y: "479",
                rx: "0",
                ry: "0",
                width: "2",
                height: "14"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "753",
                y: "127",
                rx: "20",
                ry: "20",
                width: "101",
                height: "32"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "872",
                y: "128",
                rx: "21",
                ry: "21",
                width: "85",
                height: "32"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "972",
                y: "125",
                rx: "20",
                ry: "20",
                width: "146",
                height: "32"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "1133",
                y: "127",
                rx: "20",
                ry: "20",
                width: "66",
                height: "32"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "828",
                y: "190",
                rx: "0",
                ry: "0",
                width: "175",
                height: "16"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "937",
                y: "194",
                rx: "0",
                ry: "0",
                width: "8",
                height: "8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "854",
                y: "224",
                rx: "0",
                ry: "0",
                width: "80",
                height: "80"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "954",
                y: "224",
                rx: "0",
                ry: "0",
                width: "80",
                height: "80"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "753",
                y: "309",
                rx: "0",
                ry: "0",
                width: "80",
                height: "5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "753",
                y: "364",
                rx: "0",
                ry: "0",
                width: "53",
                height: "16"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "828",
                y: "348",
                rx: "25",
                ry: "25",
                width: "432",
                height: "42"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "753",
                y: "459",
                rx: "0",
                ry: "0",
                width: "140",
                height: "32"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "1150",
                y: "521",
                rx: "0",
                ry: "0",
                width: "6",
                height: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "1157",
                y: "496",
                rx: "0",
                ry: "0",
                width: "49",
                height: "5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "753",
                y: "504",
                rx: "0",
                ry: "0",
                width: "70",
                height: "12"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "753",
                y: "549",
                rx: "25",
                ry: "25",
                width: "435",
                height: "42"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "1101",
                y: "459",
                rx: "25",
                ry: "25",
                width: "48",
                height: "48"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "1213",
                y: "459",
                rx: "25",
                ry: "25",
                width: "48",
                height: "48"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "1172",
                y: "461",
                rx: "0",
                ry: "0",
                width: "16",
                height: "30"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "1212",
                y: "547",
                rx: "25",
                ry: "25",
                width: "48",
                height: "48"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "12",
                y: "627",
                rx: "0",
                ry: "0",
                width: "175",
                height: "18"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "20",
                cy: "675",
                r: "8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "40",
                y: "670",
                rx: "0",
                ry: "0",
                width: "331",
                height: "12"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "20",
                cy: "701",
                r: "8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "40",
                y: "696",
                rx: "0",
                ry: "0",
                width: "331",
                height: "12"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "20",
                cy: "727",
                r: "8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "40",
                y: "722",
                rx: "0",
                ry: "0",
                width: "331",
                height: "12"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "20",
                cy: "754",
                r: "8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "40",
                y: "749",
                rx: "0",
                ry: "0",
                width: "331",
                height: "12"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "11",
                y: "800",
                rx: "0",
                ry: "0",
                width: "566",
                height: "12"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "11",
                y: "882",
                rx: "0",
                ry: "0",
                width: "566",
                height: "12"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "11",
                y: "817",
                rx: "0",
                ry: "0",
                width: "566",
                height: "12"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "11",
                y: "838",
                rx: "0",
                ry: "0",
                width: "566",
                height: "12"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "11",
                y: "860",
                rx: "0",
                ry: "0",
                width: "566",
                height: "12"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "895",
                y: "635",
                rx: "0",
                ry: "0",
                width: "175",
                height: "18"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "903",
                cy: "683",
                r: "8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "923",
                y: "678",
                rx: "0",
                ry: "0",
                width: "331",
                height: "12"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "903",
                cy: "709",
                r: "8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "923",
                y: "704",
                rx: "0",
                ry: "0",
                width: "331",
                height: "12"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "903",
                cy: "735",
                r: "8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "923",
                y: "730",
                rx: "0",
                ry: "0",
                width: "331",
                height: "12"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "903",
                cy: "762",
                r: "8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "923",
                y: "757",
                rx: "0",
                ry: "0",
                width: "331",
                height: "12"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ResponsiveProduct);


/***/ }),

/***/ 43141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/endpoint.js
var endpoint = __webpack_require__(8646);
// EXTERNAL MODULE: ./components/index.js + 15 modules
var components = __webpack_require__(29655);
// EXTERNAL MODULE: ./components/atoms/Notifica/Notifica.js + 2 modules
var Notifica = __webpack_require__(83729);
// EXTERNAL MODULE: ./utils/HelperNewProdottoCard/utils.js
var utils = __webpack_require__(22102);
// EXTERNAL MODULE: ./utils/safe.js
var safe = __webpack_require__(46052);
// EXTERNAL MODULE: ./components/molecules/MainProdotto/MainProdotto.js
var MainProdotto = __webpack_require__(70165);
// EXTERNAL MODULE: ./components/atoms/Accordion/Accordion.js
var Accordion = __webpack_require__(13881);
;// CONCATENATED MODULE: ./components/molecules/Tabs/Tabs.js


var Tabs = function(param) {
    var tabs = param.tabs;
    var ref = (0,react.useState)(tabs[0].id), selectedTab = ref[0], setSelectedTab = ref[1];
    var ref1 = tabs.find(function(x) {
        return x.id === selectedTab;
    }), Component = ref1.component;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: "tabs_container",
                children: tabs.map(function(tab) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("button", {
                        className: selectedTab === tab.id ? 'activeTab' : 'tab',
                        onClick: function() {
                            return setSelectedTab(tab.id);
                        },
                        type: "button",
                        children: tab.label
                    }, tab.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tabs-body",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {})
            })
        ]
    }));
};
/* harmony default export */ var Tabs_Tabs = (Tabs);

// EXTERNAL MODULE: ./components/atoms/NewIcons/index.js + 67 modules
var NewIcons = __webpack_require__(20474);
// EXTERNAL MODULE: ./components/atoms/Button/Button.js
var Button = __webpack_require__(81642);
// EXTERNAL MODULE: ./utils/index.js
var utils_0 = __webpack_require__(85313);
// EXTERNAL MODULE: ./components/atoms/index.js + 2 modules
var atoms = __webpack_require__(44043);
// EXTERNAL MODULE: ./hooks/useTrans.js
var useTrans = __webpack_require__(49896);
// EXTERNAL MODULE: ./components/atoms/Trans/Trans.js
var Trans = __webpack_require__(53845);
;// CONCATENATED MODULE: ./components/molecules/DettagliProdottoListino/DettagliProdottoListino.js




var DettagliProdottoListino = function(param) {
    var prezzi = param.prezzi, prezziTransfer = param.prezziTransfer, refTableSchedaProdotto = param.refTableSchedaProdotto;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "dettagli-prodotto__listino",
        children: [
            Object.entries(prezzi).map(function(item, i) {
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    className: "dettagli-prodotto__listino__block",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "dettagli-prodotto__listino__block-title",
                            children: item[1][0].nome
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "dettagli-prodotto__listino__table",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "dettagli-prodotto__listino__col",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "dettagli-prodotto__listino__cell dettagli-prodotto__listino__cell--title",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                                chiave: "Quantit\xe0 fina a"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "dettagli-prodotto__listino__cell dettagli-prodotto__listino__cell--title",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                                chiave: "Prezzo personalizz."
                                            })
                                        })
                                    ]
                                }),
                                item[1].map(function(obj, j) {
                                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "dettagli-prodotto__listino__col",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "dettagli-prodotto__listino__cell dettagli-prodotto__listino__cell--quantity",
                                                children: obj.fino_a
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "dettagli-prodotto__listino__cell",
                                                children: [
                                                    (0,safe/* priceNotation */._q)(obj.prezzo_personalizzazione, 3),
                                                    " €"
                                                ]
                                            })
                                        ]
                                    }, j));
                                })
                            ]
                        })
                    ]
                }, i);
            }),
            prezziTransfer && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "dettagli-prodotto__listino__block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "dettagli-prodotto__listino__block-title",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                            chiave: "Transfer"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "dettagli-prodotto__listino__table",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "dettagli-prodotto__listino__col",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "dettagli-prodotto__listino__cell dettagli-prodotto__listino__cell--title",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                            chiave: "Quantit\xe0 fino a"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "dettagli-prodotto__listino__cell dettagli-prodotto__listino__cell--title",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                            chiave: "Prezzo personalizz."
                                        })
                                    })
                                ]
                            }),
                            prezziTransfer.map(function(obj) {
                                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "dettagli-prodotto__listino__col",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "dettagli-prodotto__listino__cell dettagli-prodotto__listino__cell--quantity",
                                            children: (0,safe/* numberNotation */.Qw)(obj.qta)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "dettagli-prodotto__listino__cell",
                                            children: [
                                                (0,safe/* priceNotation */._q)(obj.prezzo, 3),
                                                " €"
                                            ]
                                        })
                                    ]
                                }));
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var DettagliProdottoListino_DettagliProdottoListino = (DettagliProdottoListino);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
;// CONCATENATED MODULE: ./components/molecules/DettagliProdotto/DettagliProdotto.js














function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var DettagliProdottoRecapItem = function(param) {
    var label = param.label, value = param.value;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "dettagli-prodotto__recap__item",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "dettagli-prodotto__recap__label",
                children: [
                    label,
                    ":"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "dettagli-prodotto__recap__value",
                children: value
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "dettagli-prodotto__recap__arrow",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewIcons/* ChevronDown */._M, {})
            })
        ]
    }));
};
var DettagliProdottoData = function(param) {
    var label = param.label, value = param.value, _html = param.html, html = _html === void 0 ? false : _html;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "dettagli-prodotto__data",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "dettagli-prodotto__data__label",
                children: label
            }),
            html ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "dettagli-prodotto__data__value",
                dangerouslySetInnerHTML: {
                    __html: value
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "dettagli-prodotto__data__value",
                children: value
            })
        ]
    }));
};
var DettagliProdottoDocumentazioneButton = function(param) {
    var label = param.label, url = param.url, file_name = param.file_name;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "dettagli-prodotto__documentazione__button-wrap",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: url,
            download: true,
            target: "_blank",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                label: label,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewIcons/* Download */.UW, {}),
                icon_pos: "left",
                variant: "ghost",
                color: "black",
                size: "medium"
            })
        })
    }));
};
var DettagliProdotto = function(param) {
    var selectedItem = param.selectedItem, selectedColor = param.selectedColor, selectedTaglia = param.selectedTaglia, prodotto = param.prodotto, selectorTaglia = param.selectorTaglia, selectorColore = param.selectorColore;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var ref9 = (0,react.useState)({}), prezzi = ref9[0], setPrezzi = ref9[1];
    var ref10 = (0,react.useState)(null), pers = ref10[0], setPers = ref10[1];
    var ref11 = (0,react.useState)(false), open = ref11[0], setOpen = ref11[1];
    var t = (0,useTrans/* default */.Z)();
    var refTableSchedaProdotto = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var service_gift = (0,es/* useSelector */.v9)(function(state) {
        return state.servicegift;
    }).service_gift;
    (0,react.useEffect)(function() {
        var params = {
            lang: router.locale
        };
        utils_0/* api.get */.hi.get("".concat(endpoint/* PRODOTTI */.e0).concat(prodotto.codice).concat(endpoint/* COSTIPERSONALIZZAZIONE */._E), {
            params: params
        }).then(function(data) {
            setPrezzi(data.data);
        });
        utils_0/* api.get */.hi.get("".concat(endpoint/* PRODOTTI */.e0).concat(prodotto.codice).concat(endpoint/* PERSONALIZZAZIONI */.Xl), {
            params: params
        }).then(function(data) {
            return setPers(data.data);
        });
    }, []);
    (0,react.useEffect)(function() {}, [
        refTableSchedaProdotto
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "dettagli-prodotto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "dettagli-prodotto__header",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "dettagli-prodotto__title",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Trans */.cC, {
                            chiave: "Dettagli prodotto"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "dettagli-prodotto__subtitle",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Trans */.cC, {
                                    chiave: "Trova tutti i dettagli dell'articolo"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Trans */.cC, {
                                    chiave: "Puoi selezionare una referenza di tuo interesse per visualizzarne le relative informazioni"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "dettagli-prodotto__recap",
                children: [
                    selectedColor && (selectorColore ? selectorColore : /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdottoRecapItem, {
                        label: t('Colore'),
                        value: selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.nome
                    })),
                    selectedTaglia && (selectorTaglia ? selectorTaglia : /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdottoRecapItem, {
                        label: t('Taglia'),
                        value: selectedTaglia === null || selectedTaglia === void 0 ? void 0 : selectedTaglia.nome
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "dettagli-prodotto__accordions",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                        placeholder: t('Specifiche'),
                        size: "extralarge",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "dettagli-prodotto__accordion-content",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "dettagli-prodotto__data-list",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdottoData, {
                                        label: t('Codice articolo'),
                                        value: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.codice
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdottoData, {
                                        label: t('Colore'),
                                        value: selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.nome
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdottoData, {
                                        label: t('Colori disponibili'),
                                        value: prodotto.colori.map(function(item) {
                                            return item === null || item === void 0 ? void 0 : item.nome;
                                        }).join(', ')
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdottoData, {
                                        label: t('Descrizione'),
                                        value: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.descrizione_lunga) ? selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.descrizione_lunga : selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.descrizione,
                                        html: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.descrizione_lunga) ? true : false
                                    }),
                                    prodotto.materiale && /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdottoData, {
                                        label: t('Materiale'),
                                        value: (ref = prodotto.materiale) === null || ref === void 0 ? void 0 : ref.nome
                                    }),
                                    prodotto.taglie.length > 0 && selectedTaglia && /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdottoData, {
                                        label: t('Taglie disponibili'),
                                        value: prodotto.taglie.filter(function(item) {
                                            return item.id != selectedTaglia.id;
                                        }).map(function(item) {
                                            return item === null || item === void 0 ? void 0 : item.nome;
                                        }).join('/')
                                    }),
                                    (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.attributi_lista.filter(function(item) {
                                        return item.attributo_chiave == 'manico';
                                    }).length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdottoData, {
                                        label: t('Misure manico'),
                                        value: (ref1 = selectedItem.attributi_lista.filter(function(item) {
                                            return item.attributo_chiave == 'manico';
                                        })[0]) === null || ref1 === void 0 ? void 0 : ref1.nome
                                    }),
                                    (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.attributi_lista.filter(function(item) {
                                        return item.attributo_chiave == 'capacita';
                                    }).length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdottoData, {
                                        label: t('Capacit\xe0'),
                                        value: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "dettagli-prodotto__capacita",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "dettagli-prodotto__capacita__tag",
                                                    children: (ref2 = selectedItem.attributi_lista.filter(function(item) {
                                                        return item.attributo_chiave == 'capacita';
                                                    })[0]) === null || ref2 === void 0 ? void 0 : ref2.nome
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "dettagli-prodotto__capacita__label",
                                                    children: (ref3 = selectedItem.attributi_lista.filter(function(item) {
                                                        return item.attributo_chiave == 'capacita';
                                                    })[0]) === null || ref3 === void 0 ? void 0 : ref3.nome
                                                })
                                            ]
                                        })
                                    }),
                                    prodotto.brand && /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdottoData, {
                                        label: t('Marchio'),
                                        value: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: prodotto.brand.image,
                                            alt: prodotto.brand.nome,
                                            title: prodotto.brand.nome
                                        })
                                    }),
                                    prodotto.voce_doganale && /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdottoData, {
                                        label: t('Codice Doganale'),
                                        value: prodotto.voce_doganale ? prodotto.voce_doganale : '-'
                                    }),
                                    prodotto.dimensione_legacy && /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdottoData, {
                                        label: t('Dimensioni'),
                                        value: prodotto.dimensione_legacy
                                    }),
                                    (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.grammatura) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdottoData, {
                                        label: t('Grammatura'),
                                        value: selectedItem.grammatura
                                    }),
                                    (prodotto === null || prodotto === void 0 ? void 0 : (ref4 = prodotto.alternativo) === null || ref4 === void 0 ? void 0 : ref4.codice) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdottoData, {
                                        label: t('Prodotto alternativo'),
                                        value: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: prodotto.alternativo.url,
                                            children: prodotto.alternativo.codice
                                        })
                                    }),
                                    (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.note) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdottoData, {
                                        label: t('Note'),
                                        value: selectedItem.note ? selectedItem.note : '-',
                                        html: true
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                        placeholder: t('Info imballi'),
                        size: "extralarge",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "dettagli-prodotto__accordion-content",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "dettagli-prodotto__data-list",
                                children: [
                                    (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.attributi_lista.filter(function(item) {
                                        return item.attributo == 11;
                                    })[0]) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdottoData, {
                                        label: t('Tipo confezione'),
                                        value: (ref5 = selectedItem.attributi_lista.filter(function(item) {
                                            return item.attributo == 11;
                                        })[0]) === null || ref5 === void 0 ? void 0 : ref5.nome
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdottoData, {
                                        label: t('Imballi'),
                                        value: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "dettagli-prodotto__imballo",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "dettagli-prodotto__imballo__icon",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewIcons/* Imballi */.Ac, {})
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "dettagli-prodotto__imballo__label",
                                                    children: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.imballi
                                                })
                                            ]
                                        })
                                    }),
                                    (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.sotto_imballi) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdottoData, {
                                        label: t('Sotto imballi'),
                                        value: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "dettagli-prodotto__imballo",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "dettagli-prodotto__imballo__icon",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewIcons/* Imballi */.Ac, {})
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "dettagli-prodotto__imballo__label",
                                                    children: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.sotto_imballi
                                                })
                                            ]
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdottoData, {
                                        label: t('Dimensione'),
                                        value: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "dettagli-prodotto__dimensioni",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "dettagli-prodotto__dimensioni__tag",
                                                    children: [
                                                        selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.altezza_imballo,
                                                        "x",
                                                        selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.larghezza_imballo,
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        "x ",
                                                        selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.profondita_imballo,
                                                        " cm"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "dettagli-prodotto__dimensioni__label",
                                                    children: [
                                                        selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.altezza_imballo,
                                                        " x ",
                                                        selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.larghezza_imballo,
                                                        " x",
                                                        ' ',
                                                        selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.profondita_imballo,
                                                        " (cm)"
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.volume_imballo) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdottoData, {
                                        label: t('Volume Collo'),
                                        value: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.volume_imballo
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.peso) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdottoData, {
                                        label: t('Peso lordo collo'),
                                        value: String(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.peso.toFixed(2)).replace('.', ',') + ' Kg'
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                ]
                            })
                        })
                    }),
                    pers && (pers === null || pers === void 0 ? void 0 : (ref6 = pers.tecniche) === null || ref6 === void 0 ? void 0 : ref6.length) > 0 && (!service_gift || (service_gift === null || service_gift === void 0 ? void 0 : service_gift.personalizzazione)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                        placeholder: t('Opzioni di personalizzazione'),
                        size: "extralarge",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "dettagli-prodotto__accordion-content",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdottoTabPersonalizzazione, {
                                pers: pers,
                                setOpen: setOpen,
                                t: t,
                                prodotto: prodotto,
                                refTableSchedaProdotto: refTableSchedaProdotto
                            })
                        })
                    }),
                    selectedItem && (selectedItem.url_scheda_tecnica || selectedItem.url_scheda_conformita || ((ref7 = selectedItem.documenti) === null || ref7 === void 0 ? void 0 : ref7.length)) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                        placeholder: t('Documentazione'),
                        size: "extralarge",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "dettagli-prodotto__accordion-content",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "dettagli-prodotto__documentazione",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "dettagli-prodotto__documentazione__buttons",
                                    children: [
                                        selectedItem.documenti.map(function(item) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(DettagliProdottoDocumentazioneButton, {
                                                label: item === null || item === void 0 ? void 0 : item.nome,
                                                url: "".concat(item.url),
                                                file_name: item.label
                                            });
                                        }),
                                        (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.url_scheda_tecnica) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdottoDocumentazioneButton, {
                                            label: t('Scarica scheda prodotto in pdf'),
                                            url: "".concat(selectedItem.url_scheda_tecnica)
                                        })
                                    ]
                                })
                            })
                        })
                    }) : '',
                    pers && (pers === null || pers === void 0 ? void 0 : (ref8 = pers.tecniche) === null || ref8 === void 0 ? void 0 : ref8.length) > 0 && (!service_gift || (service_gift === null || service_gift === void 0 ? void 0 : service_gift.personalizzazione)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                        initialValue: open,
                        placeholder: t('Listino prezzi per personalizzazione'),
                        size: "extralarge",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "dettagli-prodotto__accordion-content",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdottoListino_DettagliProdottoListino, {
                                refTableSchedaProdotto: refTableSchedaProdotto,
                                prezzi: prezzi,
                                prezziTransfer: null
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: function(el) {
                            return refTableSchedaProdotto.current = el;
                        }
                    })
                ]
            })
        ]
    }));
};
var DettagliProdottoTab = function(param) {
    var item = param.item, setOpen = param.setOpen, t = param.t, prodotto = param.prodotto, refTableSchedaProdotto = param.refTableSchedaProdotto;
    var ref15, ref12, ref13, ref14;
    var HandleVisualizzaPrezzi = function() {
        var ref;
        setOpen(true);
        refTableSchedaProdotto === null || refTableSchedaProdotto === void 0 ? void 0 : (ref = refTableSchedaProdotto.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView();
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "dettagli-prodotto__data-list",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdottoData, {
                label: t('Tecnica di stampa'),
                value: item === null || item === void 0 ? void 0 : item.nome
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdottoData, {
                label: t('Posizione di stampa consigliata'),
                value: (ref15 = item.posizioni[0]) === null || ref15 === void 0 ? void 0 : ref15.nome
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdottoData, {
                label: t('Max. misure di stampa'),
                value: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "dettagli-prodotto__misure",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "dettagli-prodotto__misure__item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "dettagli-prodotto__misure__icon",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewIcons/* Altezza */.LP, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "dettagli-prodotto__misure__label",
                                    children: [
                                        item.posizioni[0].numero_colori[0].personalizzazioni_objects[0].altezza_massima,
                                        " cm"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "dettagli-prodotto__misure__item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "dettagli-prodotto__misure__icon",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewIcons/* Larghezza */.KX, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "dettagli-prodotto__misure__label",
                                    children: [
                                        item.posizioni[0].numero_colori[0].personalizzazioni_objects[0].base_massima,
                                        " cm"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdottoData, {
                label: t('Max. numero colori di stampa'),
                value: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "dettagli-prodotto__colori",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "dettagli-prodotto__colori__row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "dettagli-prodotto__colori__icon",
                                    children: item.posizioni[0].numero_colori.length > 0 ? _toConsumableArray(Array(item.posizioni[0].numero_colori.length)).map(function(k) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(NewIcons/* Goccia */.Z9, {}, k);
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "dettagli-prodotto__colori__label",
                                    children: item.posizioni[0].numero_colori.length > 0 && item.posizioni[0].numero_colori[0].codice === '000' ? item.posizioni[0].numero_colori[0].nome : item.posizioni[0].numero_colori.length
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "dettagli-prodotto__colori__show-prezzi",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                onClick: function() {
                                    return HandleVisualizzaPrezzi();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Trans */.cC, {
                                    chiave: "Visualizza prezzi"
                                })
                            })
                        })
                    ]
                })
            }),
            (prodotto === null || prodotto === void 0 ? void 0 : (ref12 = prodotto.attributi_lista) === null || ref12 === void 0 ? void 0 : ref12.filter(function(attributo) {
                return (attributo === null || attributo === void 0 ? void 0 : attributo.attributo_chiave) === 'confezionamento';
            }).length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdottoData, {
                label: t('Tipo confezionamento dopo personalizzazione'),
                value: (ref14 = prodotto === null || prodotto === void 0 ? void 0 : (ref13 = prodotto.attributi_lista) === null || ref13 === void 0 ? void 0 : ref13.filter(function(attributo) {
                    return (attributo === null || attributo === void 0 ? void 0 : attributo.attributo_chiave) === 'confezionamento';
                })[0]) === null || ref14 === void 0 ? void 0 : ref14.nome
            })
        ]
    }));
};
var DettagliProdottoTabPersonalizzazione = function(param) {
    var pers = param.pers, setOpen = param.setOpen, t = param.t, prodotto = param.prodotto, refTableSchedaProdotto = param.refTableSchedaProdotto;
    var ref;
    if (!pers || !((ref = pers.tecniche) === null || ref === void 0 ? void 0 : ref.length)) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}));
    }
    var data = pers.tecniche.map(function(item) {
        return {
            label: item === null || item === void 0 ? void 0 : item.nome,
            id: item.id,
            component: function() {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(DettagliProdottoTab, {
                    setOpen: setOpen,
                    item: item,
                    t: t,
                    prodotto: prodotto,
                    refTableSchedaProdotto: refTableSchedaProdotto
                });
            }
        };
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs_Tabs, {
        tabs: data
    }));
};
/* harmony default export */ var DettagliProdotto_DettagliProdotto = (/*#__PURE__*/react.memo(DettagliProdotto));

// EXTERNAL MODULE: ./components/organisms/FormPersonalizzazione/FormPersonalizzazione.js + 7 modules
var FormPersonalizzazione = __webpack_require__(8110);
// EXTERNAL MODULE: ./components/molecules/ProdottoPersonalizzazioneCard/ProdottoPersonalizzazioneCard.js
var ProdottoPersonalizzazioneCard = __webpack_require__(80125);
// EXTERNAL MODULE: ./context/QuantitaContext.js
var QuantitaContext = __webpack_require__(5456);
// EXTERNAL MODULE: ./components/molecules/NewTableSchedaProdotto/NewTableSchedaProdotto.js + 1 modules
var NewTableSchedaProdotto = __webpack_require__(81879);
// EXTERNAL MODULE: ./components/organisms/ModificaArticoli/ModificaArticoli.js
var ModificaArticoli = __webpack_require__(15809);
// EXTERNAL MODULE: ./components/molecules/NewModal/NewModal.js
var NewModal = __webpack_require__(10481);
// EXTERNAL MODULE: ./components/molecules/ModalBlocks/ModalBlocks.js
var ModalBlocks = __webpack_require__(19004);
// EXTERNAL MODULE: ./components/atoms/Loading/Loading.js
var Loading_Loading = __webpack_require__(4674);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
;// CONCATENATED MODULE: ./components/molecules/NonHaiTrovatoBox/NonHaiTrovatoBox.js





function _throw(e) {
    throw e;
}
var NonHaiTrovatoBox = function(param) {
    var param = param !== null ? param : _throw(new TypeError("Cannot destructure undefined"));
    var t = (0,useTrans/* default */.Z)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "nonhaitrovato",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "nonhaitrovato__content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "nonhaitrovato__title",
                        children: t('Non hai trovato quello che stai cercando?')
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "nonhaitrovato__description",
                        children: t('Contattaci per ricevere asistenza oppure richiedi il tuo ordine personalizzato')
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "nonhaitrovato__buttons",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: "/contatti",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                    variant: "secondary",
                                    colorVariant: "black",
                                    label: t('Contattaci'),
                                    size: "large",
                                    responsive: true,
                                    className: "nonhaitrovato__button"
                                })
                            })
                        })
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ var NonHaiTrovatoBox_NonHaiTrovatoBox = (NonHaiTrovatoBox);

;// CONCATENATED MODULE: ./components/organisms/AttributoSelector/AttributoSelector.js



var AttributoSelector = function(param) {
    var setSelectedAttributo = param.setSelectedAttributo, selectedAttributo = param.selectedAttributo, Attributi = param.Attributi, label = param.label;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            position: 'relative'
        },
        className: "attributo-selector",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "attributo-selector__label",
                onClick: function() {
                    return setOpen(function(prev) {
                        return !prev;
                    });
                },
                children: [
                    label,
                    ": ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "attributo-selector__label-value",
                        children: selectedAttributo === null || selectedAttributo === void 0 ? void 0 : selectedAttributo.nome
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "attributo-selector__label-arrow",
                        children: !open ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NewIcons/* ChevronDown */._M, {
                            style: {
                                maxWidth: 30
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NewIcons/* ChevronUp */.Kh, {
                            style: {
                                maxWidth: 30
                            }
                        })
                    })
                ]
            }),
            open && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    position: 'absolute',
                    top: '20px'
                },
                className: "attributo-selector__options",
                children: Attributi === null || Attributi === void 0 ? void 0 : Attributi.map(function(attributo) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("p", {
                        className: "attributo-selector__label-value",
                        onClick: function() {
                            setSelectedAttributo(attributo);
                            setOpen(false);
                        },
                        children: attributo === null || attributo === void 0 ? void 0 : attributo.nome
                    });
                })
            })
        ]
    }));
};
/* harmony default export */ var AttributoSelector_AttributoSelector = (AttributoSelector);

// EXTERNAL MODULE: ./components/molecules/OrdineRiepilogoCard/OrdineRiepilogoCard.js
var OrdineRiepilogoCard = __webpack_require__(58658);
// EXTERNAL MODULE: ./context/ProdottoContext.js
var ProdottoContext = __webpack_require__(11745);
;// CONCATENATED MODULE: ./components/template/ProdottoTemplate/ProdottoTemplate.js




















function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
//bisognerà oscurare "Le nostre Scelte" -> nel caso dovesse esistere il service Gift
var ProdottoTemplate = function(param) {
    var prodotto = param.prodotto, selectedArticolo = param.selectedArticolo, selectedTaglia = param.selectedTaglia, setSelectedTaglia = param.setSelectedTaglia, selectedColor = param.selectedColor, HandleColorClick = param.HandleColorClick, prodottoWishlist = param.prodottoWishlist, ArrowClick = param.ArrowClick, AddToCart = param.AddToCart, utente = param.utente, AddToCartMain = param.AddToCartMain, carrello = param.carrello, service_gift = param.service_gift, setCarrello = param.setCarrello, SaveLater = param.SaveLater, deleteRigaCarrello = param.deleteRigaCarrello, changingPreventivo = param.changingPreventivo, OnClickRichiedi = param.OnClickRichiedi, consegna = param.consegna, setSelectedColor = param.setSelectedColor, OrdinaSubito = param.OrdinaSubito, setReload = param.setReload;
    var ref9, ref1, ref2, ref3, ref4;
    var ref5 = (0,react.useContext)(QuantitaContext/* QuantitaContext */.h), handleQuantita = ref5.handleQuantita, onChangeInputQuantita = ref5.onChangeInputQuantita, disabled = ref5.disabled, isValid = ref5.isValid, getError = ref5.getError, getQuantita = ref5.getQuantita, quantita = ref5.quantita;
    var refTableSchedaProdotto = (0,react.useRef)(null);
    var refDettagliScheda = (0,react.useRef)(null);
    var refPersonalizzazione = (0,react.useRef)(null);
    var ref6 = (0,react.useState)(false), showPersonalizzaForm = ref6[0], setShowPersonalizzaForm = ref6[1];
    var ref7 = (0,react.useState)(false), showModificaArticoli = ref7[0], setShowModificaArticoli = ref7[1];
    var ref8 = (0,react.useState)(), editArticoloProps = ref8[0], setEditArticoloProps = ref8[1];
    var t = (0,useTrans/* default */.Z)();
    var scrollTo = function(ref) {
        (0,safe/* handleScrollRef */._V)(ref);
    };
    (0,react.useEffect)(function() {
        showPersonalizzaForm === true && scrollTo(refPersonalizzazione);
    }, [
        showPersonalizzaForm
    ]);
    var checkErrors = function() {
        var ref;
        var valid = true;
        // ? E' stato aggiunto il check e il filtro per gli articolo che sono esclusi dalla personalizzazione
        var valore = (ref = quantita === null || quantita === void 0 ? void 0 : quantita.filter(function(item) {
            return (item === null || item === void 0 ? void 0 : item.escludi_da_listino_di_stampa) !== true;
        })) === null || ref === void 0 ? void 0 : ref.reduce(function(previus, current) {
            return previus + current.quantita;
        }, 0);
        !(valore >= ((utente === null || utente === void 0 ? void 0 : utente.ignora_minimi_stampa) ? 0 : prodotto === null || prodotto === void 0 ? void 0 : prodotto.quantita_minima_personalizzabile)) && (valid = false);
        if (valid && isValid()) {
            return true;
        } else {
            return false;
        }
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(ProdottoContext/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MainProdotto/* default */.Z, {
                        setSelectedTaglia: setSelectedTaglia,
                        utente: utente,
                        indirizzo: "prova",
                        consegna: consegna,
                        mail_campioni: prodotto.mailto_campioni,
                        prodotto: prodotto,
                        selectedArticolo: selectedArticolo,
                        selectedTaglia: selectedTaglia,
                        selectedColor: selectedColor,
                        HandleColorClick: HandleColorClick,
                        wishlist: prodottoWishlist,
                        ArrowClick: ArrowClick,
                        service_gift: service_gift,
                        scrollToDettagli: function() {
                            return scrollTo(refDettagliScheda);
                        },
                        scrollToTableSchedaProdotto: function() {
                            return scrollTo(refTableSchedaProdotto);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "prodotto-template__cols",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "prodotto-template__main",
                                children: [
                                    (utente || service_gift && !service_gift.premium) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: refTableSchedaProdotto,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "prodotto-template__block",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewTableSchedaProdotto/* default */.ZP, {
                                                selectorTaglia: selectedTaglia && /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributoSelector_AttributoSelector, {
                                                    label: t('Taglia'),
                                                    Attributi: (ref1 = prodotto === null || prodotto === void 0 ? void 0 : (ref9 = prodotto.colori) === null || ref9 === void 0 ? void 0 : ref9.filter(function(colore) {
                                                        return colore.id === selectedColor.id;
                                                    })[0]) === null || ref1 === void 0 ? void 0 : ref1.taglie,
                                                    selectedAttributo: selectedTaglia,
                                                    setSelectedAttributo: setSelectedTaglia
                                                }),
                                                selectorColore: selectedColor && /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributoSelector_AttributoSelector, {
                                                    label: t('Colore'),
                                                    Attributi: prodotto === null || prodotto === void 0 ? void 0 : prodotto.colori,
                                                    selectedAttributo: selectedColor,
                                                    setSelectedAttributo: setSelectedColor
                                                }),
                                                utente: utente,
                                                quantita: quantita,
                                                setSelectedTaglia: setSelectedTaglia,
                                                setSelectedColor: selectedColor,
                                                showPersonalizzaForm: showPersonalizzaForm,
                                                setShowPersonalizzaForm: setShowPersonalizzaForm,
                                                selectedArticolo: selectedArticolo,
                                                prodotto: prodotto,
                                                handleQuantita: handleQuantita,
                                                onChangeInputQuantita: onChangeInputQuantita,
                                                disabled: disabled,
                                                isValid: isValid,
                                                articoliQuantita: quantita,
                                                AddToCart: AddToCart,
                                                service_gift: service_gift,
                                                OnClickRichiedi: OnClickRichiedi
                                            })
                                        })
                                    }),
                                    utente && (!service_gift || (service_gift === null || service_gift === void 0 ? void 0 : service_gift.premium)) && showPersonalizzaForm && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "prodotto-template__block",
                                        ref: refPersonalizzazione,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormPersonalizzazione/* default */.Z, {
                                            prodotto: prodotto,
                                            setShowPersonalizzaForm: setShowPersonalizzaForm,
                                            articoliQuantita: quantita === null || quantita === void 0 ? void 0 : quantita.filter(function(item) {
                                                return (item === null || item === void 0 ? void 0 : item.escludi_da_listino_di_stampa) !== true;
                                            }),
                                            prodottoId: prodotto.codice,
                                            AddToCart: AddToCart,
                                            ErroreQuantita: !checkErrors(),
                                            setReload: setReload,
                                            children: [
                                                quantita && quantita.sort(function(a, b) {
                                                    return a.codice == selectedArticolo.codice ? -1 : b.codice == selectedArticolo.codice ? 1 : 0;
                                                }).filter(function(item) {
                                                    return (item === null || item === void 0 ? void 0 : item.quantita) > 0 && (item === null || item === void 0 ? void 0 : item.escludi_da_listino_di_stampa) !== true;
                                                }).map(function(item) {
                                                    var ref, ref10, ref11;
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ProdottoPersonalizzazioneCard/* default */.Z, {
                                                        prodotto: prodotto.articoli.filter(function(element) {
                                                            return element.codice == item.codice;
                                                        })[0],
                                                        colore: (ref = prodotto.articoli.filter(function(element) {
                                                            return element.codice == item.codice;
                                                        })[0]) === null || ref === void 0 ? void 0 : ref.attributi_lista.filter(function(element) {
                                                            return element.attributo == 7;
                                                        })[0],
                                                        taglia: (ref11 = (ref10 = prodotto.articoli.filter(function(element) {
                                                            return element.codice == item.codice;
                                                        })[0]) === null || ref10 === void 0 ? void 0 : ref10.attributi_lista.filter(function(element) {
                                                            return element.attributo == 8;
                                                        })[0]) === null || ref11 === void 0 ? void 0 : ref11.nome,
                                                        onChangeInputQuantita: onChangeInputQuantita,
                                                        handleQuantita: handleQuantita,
                                                        quantitaMinimaPersonalizzabile: utente.ignora_minimi_stampa ? 0 : prodotto.quantita_minima_personalizzabile,
                                                        getError: getError,
                                                        getQuantita: getQuantita
                                                    }, item.codice);
                                                }),
                                                ((ref2 = quantita === null || quantita === void 0 ? void 0 : quantita.filter(function(item) {
                                                    return (item === null || item === void 0 ? void 0 : item.quantita) > 0 && (item === null || item === void 0 ? void 0 : item.escludi_da_listino_di_stampa) !== true;
                                                })) === null || ref2 === void 0 ? void 0 : ref2.length) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "prodotto-template__paragraph",
                                                    children: t('Inserire Quantit\xe0 maggiore di 0')
                                                })
                                            ]
                                        })
                                    }),
                                    (utente || service_gift && !service_gift.premium) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: refDettagliScheda,
                                        className: "prodotto-template__block",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DettagliProdotto_DettagliProdotto, {
                                            selectorTaglia: selectedTaglia && /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributoSelector_AttributoSelector, {
                                                label: t('Taglia'),
                                                Attributi: (ref4 = prodotto === null || prodotto === void 0 ? void 0 : (ref3 = prodotto.colori) === null || ref3 === void 0 ? void 0 : ref3.filter(function(colore) {
                                                    return colore.id === selectedColor.id;
                                                })[0]) === null || ref4 === void 0 ? void 0 : ref4.taglie,
                                                selectedAttributo: selectedTaglia,
                                                setSelectedAttributo: setSelectedTaglia
                                            }),
                                            selectorColore: selectedColor && /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributoSelector_AttributoSelector, {
                                                label: t('Colore'),
                                                Attributi: prodotto === null || prodotto === void 0 ? void 0 : prodotto.colori,
                                                selectedAttributo: selectedColor,
                                                setSelectedAttributo: setSelectedColor
                                            }),
                                            prodotto: prodotto,
                                            selectedItem: selectedArticolo,
                                            selectedColor: selectedColor,
                                            selectedTaglia: selectedTaglia
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "prodotto-template__sidebar",
                                children: [
                                    utente && (!service_gift || (service_gift === null || service_gift === void 0 ? void 0 : service_gift.premium)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrdineRiepilogoCard/* default */.Z, {
                                        isLoading: changingPreventivo,
                                        ordine: carrello,
                                        AddToCartMain: AddToCartMain,
                                        isProdotto: true,
                                        prodotto: prodotto,
                                        SaveLater: SaveLater,
                                        ModificaArticoli: function() {
                                            return setShowModificaArticoli(true);
                                        },
                                        setEditArticoloProps: setEditArticoloProps,
                                        OrdinaSubito: OrdinaSubito
                                    }),
                                    (editArticoloProps === null || editArticoloProps === void 0 ? void 0 : editArticoloProps.initialSelectedArticolo) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModificaArticoli/* default */.Z, {
                                        AddToCart: AddToCart,
                                        setCarrello: setCarrello,
                                        isVisible: editArticoloProps === null || editArticoloProps === void 0 ? void 0 : editArticoloProps.show,
                                        setVisible: function(value) {
                                            var new_value = value;
                                            setEditArticoloProps(function(prev_state) {
                                                return _objectSpread({}, prev_state, {
                                                    show: new_value
                                                });
                                            });
                                        },
                                        preventivo: carrello,
                                        prodotto: prodotto,
                                        initialStep: editArticoloProps === null || editArticoloProps === void 0 ? void 0 : editArticoloProps.initialStep,
                                        initialId: editArticoloProps === null || editArticoloProps === void 0 ? void 0 : editArticoloProps.initialId,
                                        initialSelectedArticolo: editArticoloProps === null || editArticoloProps === void 0 ? void 0 : editArticoloProps.initialSelectedArticolo,
                                        initialQuantitaProps: editArticoloProps === null || editArticoloProps === void 0 ? void 0 : editArticoloProps.initialQuantita,
                                        service_gift: service_gift
                                    }, "modifica_articoli_".concat(editArticoloProps === null || editArticoloProps === void 0 ? void 0 : editArticoloProps.initialId)),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModificaArticoli/* default */.Z, {
                                        AddToCart: AddToCart,
                                        setCarrello: setCarrello,
                                        isVisible: showModificaArticoli,
                                        setVisible: setShowModificaArticoli,
                                        preventivo: carrello,
                                        prodotto: prodotto,
                                        service_gift: service_gift
                                    }, "modifica_articoli")
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NonHaiTrovatoBox_NonHaiTrovatoBox, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteFromRiepilogoCard, {
                onDelete: _asyncToGenerator(runtime_default().mark(function _callee() {
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return deleteRigaCarrello(editArticoloProps === null || editArticoloProps === void 0 ? void 0 : editArticoloProps.initialId);
                            case 2:
                                return _ctx.abrupt("return", _ctx.sent);
                            case 3:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                })),
                visible: editArticoloProps === null || editArticoloProps === void 0 ? void 0 : editArticoloProps.show_delete,
                setVisible: function(value) {
                    return setEditArticoloProps(function(prev_state) {
                        return _objectSpread({}, prev_state, {
                            show_delete: value
                        });
                    });
                }
            })
        ]
    }));
};
/* harmony default export */ var ProdottoTemplate_ProdottoTemplate = (ProdottoTemplate);
var DeleteFromRiepilogoCard = function(param) {
    var visible = param.visible, setVisible = param.setVisible, onDelete = param.onDelete;
    var ref = (0,react.useState)(false), Loading = ref[0], setLoading = ref[1];
    var _handleDelete = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.next = 3;
                        return onDelete();
                    case 3:
                        setLoading(false);
                        setVisible(false);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function _handleDelete() {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(NewModal/* default */.Z, {
        visible: visible,
        onClose: function() {
            return setVisible(false);
        },
        title: "Sei sicuro di voler Eliminare questo articolo?",
        children: Loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading_Loading/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBlocks/* default.Actions */.Z.Actions, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                    label: "Annulla",
                    variant: "secondary",
                    onClick: function() {
                        return setVisible(false);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                    label: "Conferma e elimina",
                    variant: "primary",
                    onClick: function() {
                        onDelete && _handleDelete();
                    }
                })
            ]
        })
    }));
};

// EXTERNAL MODULE: ./components/atoms/SkeletonLoading/SkeletonLoadingProduct.js
var SkeletonLoadingProduct = __webpack_require__(88973);
// EXTERNAL MODULE: ./context/CartContext.js
var CartContext = __webpack_require__(25926);
// EXTERNAL MODULE: ./pages/cart/checkout/[token].js + 10 modules
var _token_ = __webpack_require__(38678);
// EXTERNAL MODULE: ./node_modules/@sentry/minimal/esm/index.js
var esm = __webpack_require__(39666);
// EXTERNAL MODULE: ./components/molecules/index.js + 19 modules
var molecules = __webpack_require__(36068);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/core/core-class.js + 66 modules
var core_class = __webpack_require__(30172);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/navigation/navigation.js
var navigation = __webpack_require__(95186);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/pagination/pagination.js
var pagination = __webpack_require__(52997);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/scrollbar/scrollbar.js
var scrollbar = __webpack_require__(65014);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/a11y/a11y.js
var a11y = __webpack_require__(10787);
// EXTERNAL MODULE: ./node_modules/swiper/esm/react/swiper.js + 8 modules
var swiper = __webpack_require__(69447);
// EXTERNAL MODULE: ./node_modules/swiper/esm/react/swiper-slide.js
var swiper_slide = __webpack_require__(24002);
// EXTERNAL MODULE: ./components/atoms/Tag/Tag.js
var Tag = __webpack_require__(18255);
// EXTERNAL MODULE: ./components/atoms/Color/Color.js
var Color = __webpack_require__(56708);
// EXTERNAL MODULE: ./components/atoms/MyImage/MyImage.js
var MyImage = __webpack_require__(99958);
// EXTERNAL MODULE: ./components/atoms/WishList/WishList.js
var WishList = __webpack_require__(16246);
// EXTERNAL MODULE: ./hooks/useWindowDimensions.js
var useWindowDimensions = __webpack_require__(57080);
;// CONCATENATED MODULE: ./components/molecules/SliderCard/SliderCard.jsx















core_class/* default.use */.Z.use([
    navigation/* default */.Z,
    a11y/* default */.Z
]);
var SliderCard = function(param) {
    var utente = param.utente, prodotto = param.prodotto, articoli = param.articoli, colori = param.colori, vista2 = param.vista2, handleNotification = param.handleNotification, priceLoaded = param.priceLoaded;
    var ref6;
    var ref1 = (0,react.useState)(articoli === null || articoli === void 0 ? void 0 : articoli.filter(function(item) {
        var ref, ref3, ref4, ref5;
        return ((ref3 = item === null || item === void 0 ? void 0 : (ref = item.attributi_lista) === null || ref === void 0 ? void 0 : ref.filter(function(attr) {
            return (attr === null || attr === void 0 ? void 0 : attr.attributo_chiave) === 'colore';
        })) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.id) == ((ref5 = colori[0]) === null || ref5 === void 0 ? void 0 : ref5.id);
    })[0]), selectedArticle = ref1[0], setSelectedArticle = ref1[1];
    var width = (0,useWindowDimensions/* default */.Z)().width;
    var ref2 = (0,react.useState)(prodotto.wishlist ? prodotto.wishlist : false), prodottoWishlist = ref2[0], setProdottoWishlist = ref2[1];
    var t = (0,useTrans/* default */.Z)();
    var ArrowClick = function() {
        (0,utils/* HandleWishlist */.w)(prodottoWishlist, prodotto).then(function(response) {
            setProdottoWishlist(response);
            if (handleNotification) handleNotification(prodottoWishlist);
        });
    };
    var HandleClick = function(index) {
        setSelectedArticle(articoli.filter(function(item) {
            return item.colore.id == colori[index].id;
        })[0]);
    };
    var getRandomNumber = function(max) {
        return Math.floor(Math.random() * max);
    };
    (0,react.useEffect)(function() {
        var default_articolo = articoli === null || articoli === void 0 ? void 0 : articoli.filter(function(articolo) {
            return (articolo === null || articolo === void 0 ? void 0 : articolo.default) === true;
        });
        var random_number = getRandomNumber(articoli === null || articoli === void 0 ? void 0 : articoli.length);
        (default_articolo === null || default_articolo === void 0 ? void 0 : default_articolo.length) > 0 ? setSelectedArticle(default_articolo[0]) : setSelectedArticle(articoli[random_number]);
    }, []);
    var VisualizzazionePrezzi = function() {
        var ref, ref7, ref8, ref9, ref10, ref11;
        var listino = selectedArticle === null || selectedArticle === void 0 ? void 0 : (ref = selectedArticle.listino) === null || ref === void 0 ? void 0 : ref.prezzo_listino;
        var fasce = selectedArticle === null || selectedArticle === void 0 ? void 0 : (ref7 = selectedArticle.listino) === null || ref7 === void 0 ? void 0 : ref7.con_fasce;
        var currentPrezzo = selectedArticle === null || selectedArticle === void 0 ? void 0 : (ref8 = selectedArticle.listino) === null || ref8 === void 0 ? void 0 : ref8.prezzo;
        var text = '';
        if (fasce) {
            var ref12;
            var prezzo_riservato = currentPrezzo;
            var fascia = prodotto === null || prodotto === void 0 ? void 0 : (ref12 = prodotto.listino) === null || ref12 === void 0 ? void 0 : ref12.fasce[0].prezzo;
            if (prezzo_riservato < fascia) {
                text = t('Prezzo riservato:');
            } else {
                listino = currentPrezzo;
                currentPrezzo = fascia;
                if (currentPrezzo != listino && fasce) {
                    text = t('Prezzo riservato da:');
                }
                if (currentPrezzo == listino && fasce) {
                    text = t('Prezzo da:');
                }
                if (currentPrezzo != listino && !fasce) {
                    text = t('Prezzo riservato:');
                }
                if (currentPrezzo == listino && !fasce) {
                    text = t('Prezzo:');
                }
            }
        } else {
            if (currentPrezzo != listino && fasce) {
                text = t('Prezzo riservato da:');
            }
            if (currentPrezzo == listino && fasce) {
                text = t('Prezzo da:');
            }
            if (currentPrezzo != listino && !fasce) {
                text = t('Prezzo riservato:');
            }
            if (currentPrezzo == listino && !fasce) {
                text = t('Prezzo:');
            }
        }
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "card__prezzo",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "card__prezzo__label",
                        children: text
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "card__prezzo__value",
                        children: [
                            currentPrezzo != listino && (prodotto === null || prodotto === void 0 ? void 0 : (ref9 = prodotto.listino) === null || ref9 === void 0 ? void 0 : ref9.prezzo) < ((ref11 = prodotto === null || prodotto === void 0 ? void 0 : (ref10 = prodotto.listino) === null || ref10 === void 0 ? void 0 : ref10.fasce[0]) === null || ref11 === void 0 ? void 0 : ref11.prezzo) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "card__prezzo__value__full-price",
                                children: [
                                    (0,safe/* priceNotation */._q)(listino, 3),
                                    " €"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "card__prezzo__value__final-price",
                                children: [
                                    (0,safe/* priceNotation */._q)(currentPrezzo, 3),
                                    " €"
                                ]
                            })
                        ]
                    })
                ]
            })
        }));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "card ".concat(vista2 ? 'card--vista-2' : ''),
        children: [
            prodotto.brand_image && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: prodotto.brand_image,
                className: "card__brand-image"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "card__wishlist",
                onClick: function() {
                    return ArrowClick();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WishList/* default */.Z, {
                    isActive: prodottoWishlist
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "card__image__wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: selectedArticle === null || selectedArticle === void 0 ? void 0 : selectedArticle.url,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MyImage/* default */.Z, {
                                src: (selectedArticle === null || selectedArticle === void 0 ? void 0 : selectedArticle.main_image) ? selectedArticle === null || selectedArticle === void 0 ? void 0 : selectedArticle.main_image : 'https://via.placeholder.com/264',
                                alt: selectedArticle === null || selectedArticle === void 0 ? void 0 : selectedArticle.titolo,
                                title: selectedArticle === null || selectedArticle === void 0 ? void 0 : selectedArticle.titolo,
                                width: 264,
                                height: 264
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "card__image__tag",
                        children: prodotto.trend && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, {
                            variant: prodotto.trend.codice,
                            colore: prodotto.trend.colore,
                            label: prodotto.trend.nome,
                            isBrand: false
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "card__colors swiper--colors",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper/* Swiper */.t, {
                    nested: true,
                    id: prodotto.codice,
                    navigation: true,
                    pagination: false,
                    spaceBetween: 8,
                    watchOverflow: true,
                    slidesPerView: 6,
                    breakpoints: {
                        320: {
                            slidesPerView: 6
                        },
                        375: {
                            slidesPerView: 8
                        },
                        546: {
                            slidesPerView: vista2 ? 10 : 6
                        }
                    },
                    children: colori && colori.map(function(colore, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Color/* default */.Z, {
                                isActive: (selectedArticle === null || selectedArticle === void 0 ? void 0 : selectedArticle.colore.id) == colore.id ? true : false,
                                onClick: function() {
                                    HandleClick(index);
                                },
                                img: colore === null || colore === void 0 ? void 0 : colore.image,
                                colorName: (colore === null || colore === void 0 ? void 0 : colore.codice) + ' - ' + (colore === null || colore === void 0 ? void 0 : colore.nome)
                            })
                        }, index);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "card__codice",
                children: prodotto === null || prodotto === void 0 ? void 0 : prodotto.codice
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "card__titolo over__card",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: selectedArticle === null || selectedArticle === void 0 ? void 0 : selectedArticle.url,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: (selectedArticle === null || selectedArticle === void 0 ? void 0 : selectedArticle.titolo) ? selectedArticle.titolo : ''
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "card__footer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "card__pezzi__wrapper",
                        children: utente && priceLoaded && (selectedArticle === null || selectedArticle === void 0 ? void 0 : selectedArticle.listino) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NewIcons/* CheckmarkCircle2 */.hY, {
                                    className: "card__pezzi__icon"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "card__pezzi__label",
                                    children: [
                                        selectedArticle === null || selectedArticle === void 0 ? void 0 : (ref6 = selectedArticle.listino) === null || ref6 === void 0 ? void 0 : ref6.disponibilita,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Trans */.cC, {
                                            chiave: 'Pezzi'
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    selectedArticle && VisualizzazionePrezzi()
                ]
            })
        ]
    }));
};
/* harmony default export */ var SliderCard_SliderCard = (/*#__PURE__*/react.memo(SliderCard));

;// CONCATENATED MODULE: ./components/organisms/Correlati/Correlati.jsx













function Correlati_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Correlati_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Correlati_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Correlati_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function Correlati_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Correlati_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Correlati_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
core_class/* default.use */.Z.use([
    navigation/* default */.Z,
    pagination/* default */.Z,
    scrollbar/* default */.Z,
    a11y/* default */.Z
]);
var Correlati = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                maxWidth: '100%'
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProdottiSimili, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LeNostreScelte, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(VistiDiRecente, {})
            ]
        })
    }));
};
/* harmony default export */ var Correlati_Correlati = (Correlati);
var ProdottiSimili = function() {
    var t = (0,useTrans/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var ref2 = (0,react.useState)([]), prodotti = ref2[0], setProdotti = ref2[1];
    (0,react.useEffect)(Correlati_asyncToGenerator(runtime_default().mark(function _callee() {
        var ref, ref1, prodottiSimili;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return utils_0/* api.get */.hi.get('prodotti/' + (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : (ref1 = ref.slug) === null || ref1 === void 0 ? void 0 : ref1[0]) + '/simili/', {
                        params: {
                            lang: router.locale
                        }
                    }).catch(function(err) {
                        console.log(err);
                        esm/* captureException */.Tb(err);
                    });
                case 3:
                    prodottiSimili = _ctx.sent;
                    setProdotti(prodottiSimili === null || prodottiSimili === void 0 ? void 0 : prodottiSimili.data);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(SliderProdotti, {
        title: t('Potrebbero interessarti anche'),
        prodotti: prodotti,
        defaultProdottoCard: true,
        noShallow: true
    }));
};
var LeNostreScelte = function() {
    var t = (0,useTrans/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var ref4 = (0,react.useState)([]), prodotti = ref4[0], setProdotti = ref4[1];
    (0,react.useEffect)(Correlati_asyncToGenerator(runtime_default().mark(function _callee() {
        var ref, ref3, homepageDataResponse;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return utils_0/* api.get */.hi.get(endpoint/* HOMEPAGE_DATA */.rS, {
                        params: {
                            lang: router.locale
                        }
                    }).catch(function(err) {
                        console.log(err);
                        esm/* captureException */.Tb(err);
                    });
                case 3:
                    homepageDataResponse = _ctx.sent;
                    // ? Attualmente ritorno i Best Seller mostrati in HomePage
                    setProdotti((ref3 = homepageDataResponse === null || homepageDataResponse === void 0 ? void 0 : (ref = homepageDataResponse.data) === null || ref === void 0 ? void 0 : ref.best_seller[0]) === null || ref3 === void 0 ? void 0 : ref3.prodotti_categoria);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(SliderProdotti, {
        title: t('Le nostre scelte'),
        prodotti: (prodotti === null || prodotti === void 0 ? void 0 : prodotti.slice(0, 16)) || [],
        defaultProdottoCard: true,
        noShallow: true
    }));
};
var VistiDiRecente = function() {
    var t = (0,useTrans/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var ref6 = (0,react.useState)([]), prodotti = ref6[0], setProdotti = ref6[1];
    (0,react.useEffect)(Correlati_asyncToGenerator(runtime_default().mark(function _callee() {
        var ref, ref5, response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return utils_0/* api.get */.hi.get(endpoint/* PRODOTTI_VISTI */.Y4, {
                        params: {
                            lang: router.locale,
                            codice: router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : (ref5 = ref.slug) === null || ref5 === void 0 ? void 0 : ref5[0]
                        }
                    }).catch(function(err) {
                        console.log(err);
                        esm/* captureException */.Tb(err);
                    });
                case 3:
                    response = _ctx.sent;
                    setProdotti(response === null || response === void 0 ? void 0 : response.data);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(SliderProdotti, {
        title: t('Visti di recente'),
        prodotti: (prodotti === null || prodotti === void 0 ? void 0 : prodotti.slice(0, 16)) || [],
        defaultProdottoCard: true,
        noShallow: true
    }));
};
var SliderProdotti = function(param) {
    var prodotti = param.prodotti, title = param.title, defaultProdottoCard = param.defaultProdottoCard, noShallow = param.noShallow;
    var utente = (0,es/* useSelector */.v9)(function(state) {
        return state === null || state === void 0 ? void 0 : state.utente;
    }).utente;
    return (prodotti === null || prodotti === void 0 ? void 0 : prodotti.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-container",
        style: {
            margin: '35px 0px'
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "homepage_template__section-title",
                style: {
                    textAlign: 'center',
                    marginBottom: 15
                },
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "swiper--with-pagination swiper--lateral-padding",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper/* Swiper */.t, {
                    navigation: true,
                    pagination: true,
                    spaceBetween: 48,
                    slidesPerView: 4,
                    breakpoints: {
                        320: {
                            slidesPerView: 1
                        },
                        576: {
                            slidesPerView: 2
                        },
                        991: {
                            slidesPerView: 4
                        }
                    },
                    children: prodotti === null || prodotti === void 0 ? void 0 : prodotti.map(function(prodotto) {
                        var ref10, ref7;
                        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                            children: defaultProdottoCard ? /*#__PURE__*/ (0,jsx_runtime.jsx)(molecules/* NewProdottoCard */.$1, {
                                prodotto: prodotto,
                                utente: utente,
                                noShallow: noShallow
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderCard_SliderCard, {
                                utente: utente,
                                articoli: prodotto === null || prodotto === void 0 ? void 0 : (ref10 = prodotto.articoli) === null || ref10 === void 0 ? void 0 : ref10.map(function(articolo) {
                                    var ref, ref8, ref9;
                                    return Correlati_objectSpread({}, articolo, {
                                        colore: (ref8 = articolo === null || articolo === void 0 ? void 0 : (ref = articolo.attributi_lista) === null || ref === void 0 ? void 0 : ref.filter(function(attr) {
                                            return attr.attributo_chiave === 'colore';
                                        })) === null || ref8 === void 0 ? void 0 : ref8[0],
                                        main_image: articolo === null || articolo === void 0 ? void 0 : (ref9 = articolo.immagini_urls) === null || ref9 === void 0 ? void 0 : ref9[0],
                                        listino: {
                                            prezzo_listino: articolo === null || articolo === void 0 ? void 0 : articolo.prezzo_listino,
                                            con_fasce: articolo === null || articolo === void 0 ? void 0 : articolo.con_fasce,
                                            prezzo: articolo === null || articolo === void 0 ? void 0 : articolo.prezzo,
                                            disponibilita: articolo === null || articolo === void 0 ? void 0 : articolo.disponibilita
                                        }
                                    });
                                }),
                                colori: prodotto === null || prodotto === void 0 ? void 0 : prodotto.colori,
                                prodotto: Correlati_objectSpread({}, prodotto, {
                                    articoli_colore: prodotto === null || prodotto === void 0 ? void 0 : (ref7 = prodotto.articoli) === null || ref7 === void 0 ? void 0 : ref7.map(function(p) {
                                        return Correlati_objectSpread({}, p);
                                    })
                                }),
                                priceLoaded: true
                            })
                        }, prodotto === null || prodotto === void 0 ? void 0 : prodotto.id));
                    })
                })
            })
        ]
    }) : null;
};

;// CONCATENATED MODULE: ./pages/p/[...slug].js






















function _slug_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _slug_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                _slug_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                _slug_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var SchedaProdotto = function(param) {
    var data = param.data, slug = param.slug, prodotto_articolo = param.prodotto_articolo, page = param.page, statusCode = param.statusCode;
    if (!page) return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Error, {
        statusCode: statusCode
    }));
    var utente = (0,es/* useSelector */.v9)(function(state) {
        return state.utente;
    }).utente;
    var ref17 = (0,react.useState)(data), prodotto = ref17[0], setProdotto = ref17[1];
    var ref1 = (0,react.useState)(), Loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(false), changingPreventivo = ref2[0], setChangingPreventivo = ref2[1];
    var ref3 = (0,react.useState)(true), firstFetch = ref3[0], setFirstFetch = ref3[1];
    var ref4 = (0,react.useContext)(QuantitaContext/* QuantitaContext */.h), quantita = ref4.quantita, resetAllQuantita = ref4.resetAllQuantita, getQuantita = ref4.getQuantita;
    var ref5 = (0,react.useContext)(CartContext/* CartContext */.A), refreshCart = ref5.refreshCart, setCartMain = ref5.setCartMain;
    var ref6 = (0,react.useState)(false), reload = ref6[0], setReload = ref6[1];
    var ref7 = (0,react.useState)(slug ? prodotto_articolo : prodotto.articoli[0]), selectedArticolo = ref7[0], setSelectedArticolo = ref7[1];
    var ref8 = (0,react.useState)(selectedArticolo ? selectedArticolo.attributi_lista.filter(function(item) {
        return item.attributo == 8;
    })[0] : ''), selectedTaglia = ref8[0], setTaglia = ref8[1];
    var ref9 = (0,react.useState)(selectedArticolo ? selectedArticolo.attributi_lista.filter(function(item) {
        return item.attributo == 7;
    })[0] : data.colori[0]), selectedColor = ref9[0], setColor = ref9[1];
    var ref10 = (0,react.useState)(null), carrello = ref10[0], setCarrello = ref10[1];
    var ref11 = (0,react.useContext)(QuantitaContext/* QuantitaContext */.h), initilizeCell = ref11.initilizeCell, initializeAll = ref11.initializeAll, setContextCart = ref11.setContextCart;
    var service_gift = (0,es/* useSelector */.v9)(function(state) {
        return state.servicegift;
    }).service_gift;
    var ref12 = (0,react.useState)(), consegna = ref12[0], setConsegna = ref12[1];
    var ref13 = (0,react.useState)(false), prodottoWishlist = ref13[0], setProdottoWishlist = ref13[1];
    var ref14 = (0,react.useState)(false), open = ref14[0], setOpen = ref14[1];
    var ref15 = (0,react.useState)(null), modalContent = ref15[0], setModalContent = ref15[1];
    var ref16 = (0,react.useState)(null), personalizzazionePrenotazione = ref16[0], setPersonalizzazionePrenotazione = ref16[1];
    var t = (0,useTrans/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var OrdinaSubito = function() {
        var _ref = _slug_asyncToGenerator(runtime_default().mark(function _callee() {
            var response, id, loghiMancanti;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return utils_0/* api.post */.hi.post("".concat(endpoint/* CARRELLO */.yZ).concat(carrello === null || carrello === void 0 ? void 0 : carrello.id, "/").concat(endpoint/* ORDINASUBITO */.mm), {
                            lang: router.locale
                        });
                    case 3:
                        response = _ctx.sent;
                        _ctx.next = 6;
                        return response.data;
                    case 6:
                        id = _ctx.sent.id;
                        loghiMancanti = false;
                        if (carrello.personalizzazioni_carrello) {
                            carrello.personalizzazioni_carrello.forEach(function(personalizzazione) {
                                if (personalizzazione.posizioni) {
                                    if (!personalizzazione.posizioni[0].logo_file || !personalizzazione.stesso_logo && !personalizzazione.posizioni[1].logo_file) {
                                        loghiMancanti = true;
                                    }
                                }
                            });
                        }
                        if (loghiMancanti) {
                            router.push('/cart');
                        } else {
                            router.push("/cart/checkout/".concat((0,_token_.createToken)(id)));
                        }
                        _ctx.next = 15;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        (0,Notifica/* displayNotification */.d)('error.ordinaSubito', _ctx.t0.message, 'error');
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function OrdinaSubito() {
            return _ref.apply(this, arguments);
        };
    }();
    var AddToCartMain = react.useCallback(_slug_asyncToGenerator(runtime_default().mark(function _callee() {
        var ordina_subito, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ordina_subito = _args.length > 0 && _args[0] !== void 0 ? _args[0] : false;
                    if (carrello && carrello.id) {
                        setChangingPreventivo(true);
                        utils_0/* api.post */.hi.post("".concat(endpoint/* CARRELLO */.yZ).concat(carrello.id, "/").concat(endpoint/* ADDTOMAIN */.k5), {
                            salvato_per_dopo: false,
                            lang: router.locale
                        }).then(function(response) {
                            // ! Prima veniva messo setCarrello -> Ma questa Post riceve il Carrello Main non quello Preventivo
                            setCarrello(null);
                            refreshCart();
                            (0,Notifica/* displayNotification */.d)('add_to_main', t('Hai aggiunto gli articoli nel Carrello'), 'success', function() {
                                return router.push('/cart/');
                            }, t('Vai al Carrello'));
                            setChangingPreventivo(false);
                        }).catch(function(err) {
                            setChangingPreventivo(false);
                            (0,Notifica/* displayNotification */.d)('error', err.message, 'error');
                        });
                    }
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })));
    var SaveForLater = function() {
        var _ref = _slug_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (carrello) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        utils_0/* api.post */.hi.post("".concat(endpoint/* CARRELLO */.yZ).concat(carrello.id, "/").concat(endpoint/* MOVETOLATER */.Hd), {
                            salvato_per_dopo: true,
                            lang: router.locale
                        }).then(function(response) {
                            (0,Notifica/* displayNotification */.d)('success.saveForLater', t('Hai salvato per dopo questi articoli'), 'success', function() {
                                return router.push('/cart/');
                            }, t('Vai al Carrello'));
                            setCarrello(null);
                        }).catch(function(err) {
                            return (0,Notifica/* displayNotification */.d)('error.saveFprLater', err.message, 'error');
                        });
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function SaveForLater() {
            return _ref.apply(this, arguments);
        };
    }();
    var CreateModalContent = function(articoli) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBlocks/* default.ProssimiArrivi */.Z.ProssimiArrivi, {
            articoli: articoli
        }));
    };
    var deleteRigaCarrello = function() {
        var _ref = _slug_asyncToGenerator(runtime_default().mark(function _callee(id) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return utils_0/* api.delete */.hi["delete"]("".concat(endpoint/* RIGHECARRELLO */.SL).concat(id, "/")).then(function(response) {
                            return utils_0/* api.get */.hi.get(endpoint/* CARRELLO */.yZ + carrello.id + '/', {
                                params: {
                                    lang: router.locale
                                }
                            });
                        }).then(function(res) {
                            setCarrello(res.data);
                            (0,Notifica/* displayNotification */.d)('success.delete.riga', t("Hai eliminato con successo l'articolo"));
                        }).catch(function(err) {
                            return (0,Notifica/* displayNotification */.d)('error.delete.riga', err.message, 'error');
                        }).catch(function(err) {
                            return (0,Notifica/* displayNotification */.d)('error.delete.riga', err.message, 'error');
                        });
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function deleteRigaCarrello(id) {
            return _ref.apply(this, arguments);
        };
    }();
    var CheckPrenotazione = function(articoli) {
        return articoli.filter(function(item) {
            return item.prenotazione == true && item.quantita > 0;
        });
    };
    var CarrelloPost = function(articoli) {
        var pers = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, isEdit = arguments.length > 2 ? arguments[2] : void 0, reload = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
        var elements = articoli.filter(function(item) {
            return item.quantita > 0;
        });
        var carrelloId = (carrello === null || carrello === void 0 ? void 0 : carrello.id) ? "".concat(carrello.id, "/") : '';
        setChangingPreventivo(true);
        if (elements.length == 0) {
            return;
        }
        var righe = articoli.filter(function(item) {
            return item.quantita > 0;
        }).map(function(item) {
            return {
                salvato_per_dopo: false,
                personalizzazione_carrello_id: pers,
                prossimi_arrivi_ids: item.prenotazione ? item.prossimi_arrivi ? item.prossimi_arrivi.map(function(value) {
                    return value.id;
                }) : [] : [],
                articolo_id: item.id,
                quantita: getQuantita(item === null || item === void 0 ? void 0 : item.codice)
            };
        });
        // ! Righe contiene la Quantità Giusta
        carrello ? utils_0/* api.put */.hi.put(endpoint/* CARRELLO */.yZ + carrelloId, {
            tipologia: 'PREVENTIVO',
            righe_carrello: righe,
            lang: router.locale
        }).then(function(response) {
            setChangingPreventivo(false);
            setCarrello(response.data);
            (0,Notifica/* displayNotification */.d)(response.data.id, isEdit ? t('Hai modificato la quantit\xe0 con successo') : t('Hai aggiunto con Successo gli articoli'));
        }).catch(function(err) {
            setChangingPreventivo(false);
            (0,Notifica/* displayNotification */.d)('error', err.message, 'error');
        }) : utils_0/* api.post */.hi.post(endpoint/* CARRELLO */.yZ, {
            tipologia: 'PREVENTIVO',
            lang: router.locale,
            righe_carrello: articoli.filter(function(item) {
                return item.quantita > 0;
            }).map(function(item) {
                return {
                    salvato_per_dopo: false,
                    personalizzazione_carrello_id: pers,
                    prossimi_arrivi_ids: item.prenotazione ? item.prossimi_arrivi ? item.prossimi_arrivi.map(function(value) {
                        return value.id;
                    }) : [] : [],
                    articolo_id: item.id,
                    quantita: item.quantita
                };
            })
        }).then(function(response) {
            setChangingPreventivo(false);
            setCarrello(response.data);
            (0,Notifica/* displayNotification */.d)(response.data.id, t('Hai aggiunto con Successo gli articoli'));
        }).catch(function(err) {
            (0,Notifica/* displayNotification */.d)('error', err.message);
            setChangingPreventivo(false);
        });
    };
    var resetData = function() {
        var _ref = _slug_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        resetAllQuantita();
                        _ctx.next = 3;
                        return Setup();
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function resetData() {
            return _ref.apply(this, arguments);
        };
    }();
    //TODO gestire la prenotazione sia con carrello che senza
    var AddToCart = react.useCallback(_slug_asyncToGenerator(runtime_default().mark(function _callee() {
        var articoli, pers, prenotazione, checked, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    articoli = _args.length > 0 && _args[0] !== void 0 ? _args[0] : null, pers = _args.length > 1 && _args[1] !== void 0 ? _args[1] : null, prenotazione = _args.length > 2 && _args[2] !== void 0 ? _args[2] : false;
                    if (!prenotazione) {
                        _ctx.next = 5;
                        break;
                    }
                    CarrelloPost(articoli ? articoli : quantita, pers);
                    resetData();
                    return _ctx.abrupt("return");
                case 5:
                    checked = CheckPrenotazione(articoli ? articoli : quantita);
                    checked.length > 0 && (setPersonalizzazionePrenotazione(pers), setModalContent(CreateModalContent(checked)), setOpen(true));
                    checked.length == 0 && (CarrelloPost(articoli ? articoli : quantita, pers), resetData());
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })));
    var HandleColorClick = react.useCallback(function(colore) {
        prodotto.articoli.filter(function(item) {
            return item.attributi_lista.filter(function(attributo) {
                return attributo.id === colore.id;
            }).length > 0;
        })[0] && setSelectedArticolo(prodotto.articoli.filter(function(item) {
            return item.attributi_lista.filter(function(attributo) {
                return attributo.id === colore.id;
            }).length > 0;
        })[0]);
        setColor(colore);
    });
    var ArrowClick = function() {
        (0,utils/* HandleWishlist */.w)(prodottoWishlist, prodotto).then(function(response) {
            setProdottoWishlist(response);
            (0,Notifica/* displayNotification */.d)(response, t("Hai ".concat(response ? 'Aggiunto' : 'Rimosso', " dagli elementi salvati il prodotto")));
        });
    };
    var GetWishlist = function() {
        var _ref = _slug_asyncToGenerator(runtime_default().mark(function _callee(dataFetched) {
            var params, response1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        params = {
                            elements: dataFetched.id,
                            lang: router.locale
                        };
                        if (utente) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", dataFetched);
                    case 3:
                        _ctx.next = 5;
                        return utils_0/* api.get */.hi.get(endpoint/* WISHLISTELEMENTS */.XO, {
                            params: params
                        }).then(function(response) {
                            var ref;
                            return ((ref = response.data[0]) === null || ref === void 0 ? void 0 : ref.salvato) && setProdottoWishlist(true);
                        });
                    case 5:
                        response1 = _ctx.sent;
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function GetWishlist(dataFetched) {
            return _ref.apply(this, arguments);
        };
    }();
    var GetConsegna = function() {
        var _ref = _slug_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.t0 = utente;
                        if (!_ctx.t0) {
                            _ctx.next = 4;
                            break;
                        }
                        _ctx.next = 4;
                        return utils_0/* api.get */.hi.get(endpoint/* GIORNICONSEGNA */.Gq, {
                            params: {
                                lang: router.locale
                            }
                        }).then(function(response) {
                            return setConsegna(response.data);
                        });
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function GetConsegna() {
            return _ref.apply(this, arguments);
        };
    }();
    var Setup = function() {
        var _ref = _slug_asyncToGenerator(runtime_default().mark(function _callee() {
            var ids, params, dataFetched, match_article_slug;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        firstFetch && setLoading(true);
                        ids = data.articoli.map(function(item) {
                            return item.id;
                        });
                        params = {
                            articoli_ids: ids,
                            lang: router.locale
                        };
                        dataFetched = data;
                        _ctx.prev = 4;
                        _ctx.next = 7;
                        return utils_0/* api.get */.hi.get(endpoint/* GETPRODOTTOVALUES */.RW, {
                            params: params
                        }).then(function(response) {
                            return response.data && response.data.forEach(function(element) {
                                dataFetched.articoli.filter(function(item) {
                                    return item.id == element.articolo__id;
                                }).forEach(function(articolo) {
                                    articolo.prezzo = element.prezzo;
                                    articolo.disponibilita = element.disponibilita;
                                    articolo.disponibilita_reale_maggiore = element.disponibilita_reale_maggiore;
                                    articolo.disponibilita_in_opzione = element.disponibilita_in_opzione;
                                    articolo.data_in_opzione = element.data_in_opzione;
                                    articolo.con_fasce = element.con_fasce;
                                    articolo.fasce = element.fasce;
                                    articolo.prezzo_listino = element.prezzo_listino;
                                });
                            });
                        });
                    case 7:
                        _ctx.next = 9;
                        return utils_0/* api.get */.hi.get(endpoint/* PROSSIMIARRIVI */.kn, {
                            params: {
                                lang: router.locale,
                                articolo__prodotto_id: data.id
                            }
                        }).then(function(response) {
                            return response.data && response.data.forEach(function(element) {
                                dataFetched.articoli.filter(function(item) {
                                    return item.id == element.articolo_id;
                                }).forEach(function(articolo) {
                                    if (articolo.prossimi_arrivi) {
                                        articolo.prossimi_arrivi.filter(function(check) {
                                            return check.id == element.id;
                                        }).length == 0 && articolo.prossimi_arrivi.push(element);
                                    } else {
                                        articolo.prossimi_arrivi = [];
                                        articolo.prossimi_arrivi.push(element);
                                    }
                                });
                            });
                        });
                    case 9:
                        GetWishlist(dataFetched);
                        match_article_slug = prodotto.articoli.filter(function(item) {
                            return item.slug == slug;
                        })[0];
                        slug && setSelectedArticolo(match_article_slug ? match_article_slug : prodotto.articoli[0]);
                        slug && setColor(selectedArticolo.attributi_lista.filter(function(element) {
                            return element.attributo == 7;
                        })[0]);
                        slug && setTaglia(selectedArticolo.attributi_lista.filter(function(item) {
                            return item.attributo == 8;
                        })[0]);
                        setProdotto(Object.assign({}, dataFetched));
                        GetConsegna();
                        _ctx.next = 23;
                        break;
                    case 18:
                        _ctx.prev = 18;
                        _ctx.t0 = _ctx["catch"](4);
                        console.log(_ctx.t0);
                        esm/* captureException */.Tb(_ctx.t0);
                        setLoading(false);
                    case 23:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    18
                ]
            ]);
        }));
        return function Setup() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(_slug_asyncToGenerator(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    resetAllQuantita();
                    _ctx.next = 3;
                    return Setup().then(function() {
                        firstFetch && setLoading(false);
                        firstFetch && setFirstFetch(false);
                    }).catch(function(err) {
                        setLoading(false);
                        console.log(err);
                        esm/* captureException */.Tb(err);
                    });
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), []);
    (0,react.useEffect)(_slug_asyncToGenerator(runtime_default().mark(function _callee() {
        var carrelloId;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (reload && carrello && !Loading) {
                        carrelloId = (carrello === null || carrello === void 0 ? void 0 : carrello.id) ? "".concat(carrello.id, "/") : '';
                        utils_0/* api.get */.hi.get(endpoint/* CARRELLO */.yZ + carrelloId).then(function(response) {
                            setCarrello(response.data);
                        }).catch(function(err) {});
                        setReload(false);
                    }
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        reload,
        carrello,
        Loading
    ]);
    (0,react.useEffect)(function() {
        GetConsegna();
    }, [
        utente
    ]);
    (0,react.useEffect)(function() {
        GetWishlist(data);
    }, [
        prodotto
    ]);
    (0,react.useEffect)(_slug_asyncToGenerator(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    setContextCart(carrello);
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        carrello
    ]);
    (0,react.useEffect)(function() {
        if (selectedColor && selectedTaglia) {
            var articolo = prodotto.articoli.filter(function(item) {
                return item.attributi_lista.find(function(element) {
                    return element.id === selectedColor.id;
                });
            }).find(function(item) {
                return item.attributi_lista.find(function(element) {
                    return element.id === selectedTaglia.id;
                });
            });
            articolo = articolo ? articolo : prodotto.articoli.find(function(item) {
                return item.attributi_lista.find(function(element) {
                    return element.id === selectedColor.id;
                });
            });
            setSelectedArticolo(articolo);
            setTaglia(articolo.attributi_lista.find(function(item) {
                return item.attributo == 8;
            }));
        }
    }, [
        selectedColor,
        selectedTaglia
    ]);
    var OnClickRichiedi = function() {
        var _ref = _slug_asyncToGenerator(runtime_default().mark(function _callee(id) {
            var params;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        params = {
                            lang: router.locale,
                            articolo: id
                        };
                        _ctx.next = 3;
                        return utils_0/* api.post */.hi.post("".concat(endpoint/* RICHIEDIDISPONIBILITA */.Pm), {
                            articolo: id,
                            lang: router.locale
                        }).then((0,Notifica/* displayNotification */.d)('richiesta_disponibilita', t("Verrai notificato quando l'articolo torner\xe0 disponibile"), 'success'));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function OnClickRichiedi(id) {
            return _ref.apply(this, arguments);
        };
    }();
    // PER SG NON INDICIZZO PRODOTTI
    if (service_gift) {
        page.seo.noindex = true;
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* MetaSeo */.sf, {
                seo: page.seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "page",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Breadcrumbs */.Oo, {
                            breadcrumbs: page.breadcrumbs
                        })
                    }),
                    !Loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProdottoTemplate_ProdottoTemplate, {
                        changingPreventivo: changingPreventivo,
                        deleteRigaCarrello: deleteRigaCarrello,
                        setSelectedTaglia: setTaglia,
                        setSelectedColor: setColor,
                        service_gift: service_gift,
                        utente: utente,
                        indirizzo: "prova",
                        consegna: consegna,
                        prodotto: prodotto,
                        selectedArticolo: selectedArticolo,
                        selectedTaglia: selectedTaglia,
                        selectedColor: selectedColor,
                        HandleColorClick: HandleColorClick,
                        prodottoWishlist: prodottoWishlist,
                        ArrowClick: ArrowClick,
                        articoli: prodotto.articoli,
                        codice: prodotto.codice,
                        selectedItem: selectedArticolo,
                        AddToCart: AddToCart,
                        AddToCartMain: AddToCartMain,
                        SaveLater: SaveForLater,
                        carrello: carrello,
                        setCarrello: setCarrello,
                        OnClickRichiedi: OnClickRichiedi,
                        OrdinaSubito: OrdinaSubito,
                        setReload: setReload
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonLoadingProduct/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Correlati_Correlati, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewModal/* default */.Z, {
                        visible: open,
                        alert: true,
                        title: 'La quantit\xe0 inserita non \xe8 disponibile, desideri prenotarla?',
                        text: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        t('La quantita inserita non \xe8 disponibile subito, ma \xe8 possibile prenotarla su pi\xf9 arrivi.'),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        t("L'ordine verr\xe0 evaso dal prossimo arrivo della merce che soddisfa le quantit\xe0 richieste.")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: t('Se vuoi ricevere subito gli articoli, inserisci una quantit\xe0 disponibile')
                                })
                            ]
                        }),
                        className: 'prenota-modal',
                        onClose: function() {
                            return setOpen(false);
                        },
                        actions: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                label: t('Modifica quantit\xe0'),
                                variant: "secondary",
                                size: "medium",
                                onClick: function() {
                                    return setOpen(false);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                label: t('Conferma prenotazione'),
                                variant: "primary",
                                size: "medium",
                                onClick: function() {
                                    AddToCart(null, personalizzazionePrenotazione, true);
                                    setOpen(false);
                                }
                            }), 
                        ],
                        children: modalContent
                    })
                ]
            })
        ]
    }));
};
var __N_SSP = true;
/* harmony default export */ var _slug_ = (SchedaProdotto);


/***/ }),

/***/ 52997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38557);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28262);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Pagination = {
  update: function update() {
    // Render || Update Pagination bullets/items
    var swiper = this;
    var rtl = swiper.rtl;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el; // Current/Total

    var current;
    var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

    if (swiper.params.loop) {
      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);

      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
        current -= slidesLength - swiper.loopedSlides * 2;
      }

      if (current > total - 1) current -= total;
      if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
    } else {
      current = swiper.activeIndex || 0;
    } // Types


    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      var bullets = swiper.pagination.bullets;
      var firstIndex;
      var lastIndex;
      var midIndex;

      if (params.dynamicBullets) {
        swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
        $el.css(swiper.isHorizontal() ? 'width' : 'height', swiper.pagination.bulletSize * (params.dynamicMainBullets + 4) + "px");

        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
          swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;

          if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) {
            swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (swiper.pagination.dynamicBulletIndex < 0) {
            swiper.pagination.dynamicBulletIndex = 0;
          }
        }

        firstIndex = current - swiper.pagination.dynamicBulletIndex;
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }

      bullets.removeClass(params.bulletActiveClass + " " + params.bulletActiveClass + "-next " + params.bulletActiveClass + "-next-next " + params.bulletActiveClass + "-prev " + params.bulletActiveClass + "-prev-prev " + params.bulletActiveClass + "-main");

      if ($el.length > 1) {
        bullets.each(function (bullet) {
          var $bullet = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(bullet);
          var bulletIndex = $bullet.index();

          if (bulletIndex === current) {
            $bullet.addClass(params.bulletActiveClass);
          }

          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              $bullet.addClass(params.bulletActiveClass + "-main");
            }

            if (bulletIndex === firstIndex) {
              $bullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
            }

            if (bulletIndex === lastIndex) {
              $bullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
            }
          }
        });
      } else {
        var $bullet = bullets.eq(current);
        var bulletIndex = $bullet.index();
        $bullet.addClass(params.bulletActiveClass);

        if (params.dynamicBullets) {
          var $firstDisplayedBullet = bullets.eq(firstIndex);
          var $lastDisplayedBullet = bullets.eq(lastIndex);

          for (var i = firstIndex; i <= lastIndex; i += 1) {
            bullets.eq(i).addClass(params.bulletActiveClass + "-main");
          }

          if (swiper.params.loop) {
            if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
              for (var _i = params.dynamicMainBullets; _i >= 0; _i -= 1) {
                bullets.eq(bullets.length - _i).addClass(params.bulletActiveClass + "-main");
              }

              bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(params.bulletActiveClass + "-prev");
            } else {
              $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
              $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
            }
          } else {
            $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
            $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
          }
        }
      }

      if (params.dynamicBullets) {
        var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
        var offsetProp = rtl ? 'right' : 'left';
        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', bulletsOffset + "px");
      }
    }

    if (params.type === 'fraction') {
      $el.find((0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .classesToSelector */ .Wc)(params.currentClass)).text(params.formatFractionCurrent(current + 1));
      $el.find((0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .classesToSelector */ .Wc)(params.totalClass)).text(params.formatFractionTotal(total));
    }

    if (params.type === 'progressbar') {
      var progressbarDirection;

      if (params.progressbarOpposite) {
        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
      } else {
        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
      }

      var scale = (current + 1) / total;
      var scaleX = 1;
      var scaleY = 1;

      if (progressbarDirection === 'horizontal') {
        scaleX = scale;
      } else {
        scaleY = scale;
      }

      $el.find((0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .classesToSelector */ .Wc)(params.progressbarFillClass)).transform("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")").transition(swiper.params.speed);
    }

    if (params.type === 'custom' && params.renderCustom) {
      $el.html(params.renderCustom(swiper, current + 1, total));
      swiper.emit('paginationRender', $el[0]);
    } else {
      swiper.emit('paginationUpdate', $el[0]);
    }

    if (swiper.params.watchOverflow && swiper.enabled) {
      $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
  },
  render: function render() {
    // Render Container
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el;
    var paginationHTML = '';

    if (params.type === 'bullets') {
      var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

      if (swiper.params.freeMode && !swiper.params.loop && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }

      for (var i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += "<" + params.bulletElement + " class=\"" + params.bulletClass + "\"></" + params.bulletElement + ">";
        }
      }

      $el.html(paginationHTML);
      swiper.pagination.bullets = $el.find((0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .classesToSelector */ .Wc)(params.bulletClass));
    }

    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = "<span class=\"" + params.currentClass + "\"></span>" + ' / ' + ("<span class=\"" + params.totalClass + "\"></span>");
      }

      $el.html(paginationHTML);
    }

    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = "<span class=\"" + params.progressbarFillClass + "\"></span>";
      }

      $el.html(paginationHTML);
    }

    if (params.type !== 'custom') {
      swiper.emit('paginationRender', swiper.pagination.$el[0]);
    }
  },
  init: function init() {
    var swiper = this;
    swiper.params.pagination = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .createElementIfNotDefined */ .Up)(swiper.$el, swiper.params.pagination, swiper.params.createElements, {
      el: 'swiper-pagination'
    });
    var params = swiper.params.pagination;
    if (!params.el) return;
    var $el = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(params.el);
    if ($el.length === 0) return;

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
      $el = swiper.$el.find(params.el);
    }

    if (params.type === 'bullets' && params.clickable) {
      $el.addClass(params.clickableClass);
    }

    $el.addClass(params.modifierClass + params.type);

    if (params.type === 'bullets' && params.dynamicBullets) {
      $el.addClass("" + params.modifierClass + params.type + "-dynamic");
      swiper.pagination.dynamicBulletIndex = 0;

      if (params.dynamicMainBullets < 1) {
        params.dynamicMainBullets = 1;
      }
    }

    if (params.type === 'progressbar' && params.progressbarOpposite) {
      $el.addClass(params.progressbarOppositeClass);
    }

    if (params.clickable) {
      $el.on('click', (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .classesToSelector */ .Wc)(params.bulletClass), function onClick(e) {
        e.preventDefault();
        var index = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this).index() * swiper.params.slidesPerGroup;
        if (swiper.params.loop) index += swiper.loopedSlides;
        swiper.slideTo(index);
      });
    }

    (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .extend */ .l7)(swiper.pagination, {
      $el: $el,
      el: $el[0]
    });

    if (!swiper.enabled) {
      $el.addClass(params.lockClass);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var $el = swiper.pagination.$el;
    $el.removeClass(params.hiddenClass);
    $el.removeClass(params.modifierClass + params.type);
    if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);

    if (params.clickable) {
      $el.off('click', (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .classesToSelector */ .Wc)(params.bulletClass));
    }
  }
};
/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'pagination',
  params: {
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets',
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: function formatFractionCurrent(number) {
        return number;
      },
      formatFractionTotal: function formatFractionTotal(number) {
        return number;
      },
      bulletClass: 'swiper-pagination-bullet',
      bulletActiveClass: 'swiper-pagination-bullet-active',
      modifierClass: 'swiper-pagination-',
      // NEW
      currentClass: 'swiper-pagination-current',
      totalClass: 'swiper-pagination-total',
      hiddenClass: 'swiper-pagination-hidden',
      progressbarFillClass: 'swiper-pagination-progressbar-fill',
      progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
      clickableClass: 'swiper-pagination-clickable',
      // NEW
      lockClass: 'swiper-pagination-lock'
    }
  },
  create: function create() {
    var swiper = this;
    (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .bindModuleMethods */ .cR)(swiper, {
      pagination: _extends({
        dynamicBulletIndex: 0
      }, Pagination)
    });
  },
  on: {
    init: function init(swiper) {
      swiper.pagination.init();
      swiper.pagination.render();
      swiper.pagination.update();
    },
    activeIndexChange: function activeIndexChange(swiper) {
      if (swiper.params.loop) {
        swiper.pagination.update();
      } else if (typeof swiper.snapIndex === 'undefined') {
        swiper.pagination.update();
      }
    },
    snapIndexChange: function snapIndexChange(swiper) {
      if (!swiper.params.loop) {
        swiper.pagination.update();
      }
    },
    slidesLengthChange: function slidesLengthChange(swiper) {
      if (swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    snapGridLengthChange: function snapGridLengthChange(swiper) {
      if (!swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    destroy: function destroy(swiper) {
      swiper.pagination.destroy();
    },
    'enable disable': function enableDisable(swiper) {
      var $el = swiper.pagination.$el;

      if ($el) {
        $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
      }
    },
    click: function click(swiper, e) {
      var targetEl = e.target;

      if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !(0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
        if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
        var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);

        if (isHidden === true) {
          swiper.emit('paginationShow');
        } else {
          swiper.emit('paginationHide');
        }

        swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
      }
    }
  }
});

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3714,2231,1655,1369,2400,2809,6546,9774,2888,179], function() { return __webpack_exec__(84382); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);